import React, { useEffect, useState } from "react"
import {
    DKLabel,
    DKSpinner,
    DKButton,
    DKInput,
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library"
import { biWeeklyPayDays, CONSTANTS, COUNTRY_CODE, INPUT_TYPE, payDayMonthly, payDayTwicePerMonthDays, payPeriod, PROFILE_STAGES_CONSTANT, workWeek } from "../../constants/Constant";
import Utility, { deepClone } from "../../utility/Utility";
import { COLUMN_CODE } from "../../managers/TableManger";
import EmployeeListService from "../../services/EmployeeListService";
import { PayrollManager } from "../../managers/PayrollManager"
import { FORM_FIELDS } from "./PayscheduleConstants";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import TenantManager from "../../managers/TenantManager";
import PayrollService from "../../services/PayrollService";
import AddEditPaySchedule from "../../SharedComponents/AddEditPaySchedule";
import PayScheduleService from "../../services/PayScheduleService";
import ProfileSetupService from "../../services/ProfileSetup-service";
import { convertDateToJson, reverseTimezoneOffset, scrollToError } from "../../managers/common/CommonUtil";
import { PayScheduleManager } from "../../managers/PayScheduleManager";
import { useTranslation } from "react-i18next";
import moment from "moment";

const AddEditPayschedule = (props) => {

    const { t } = useTranslation();

    /**Hooks */
    const [isProcessing, setProcessing] = useState(false);
    const [isEdit, setEditFlag] = useState(props.isEdit);
    const [formFields, setFormFields] = useState(FORM_FIELDS);
    const [defaultValues, setDefaultValues] = useState(props.defaultValues);
    const [locationListData, setLocationListData] = useState(props.data.locationData);
    const [customFieldData, setCustomFieldData] = useState(props.data.customFieldsData);
    const [formValues, setFormValues] = useState({
        applicableToAll: { id: "false", name: "No" }
    });
    const [userList, setUserList] = useState(props.data.userList);

    /**Selector */

    /**Dispatch */

    useEffect(() => {
        let fields = deepClone(formFields);
        fields = updateFormFieldValuesAndOptions(fields);
        setFormFields(fields);
    }, []);

    const onClose = (isReload) => {
        props.onClose(isReload);
    }

    const updateFormFieldValuesAndOptions = (fields) => {
        let countryCode = TenantService.get(TENANT.COUNTRY_CODE)
        const alteredConfig = [];
        fields.forEach(f => {
            switch (f.columnCode) {
                case "payPeriod":
                    let payPeriodOptions = []
                    switch (countryCode) {
                        case COUNTRY_CODE.INDIA:
                            payPeriodOptions = payPeriod.filter(res => {
                                if (res.id == 'monthly') {
                                    return res
                                }
                            })
                            break;
                        case COUNTRY_CODE.US:
                            payPeriodOptions = payPeriod;
                            break;
                        default:
                            payPeriodOptions = payPeriod;
                            break;
                    }
                    formValues["payPeriod"] = EmployeeListService.getValueObjectFromDropdown(defaultValues["payPeriod"], payPeriodOptions, "id");
                    alteredConfig.push({ columnCode: "payPeriod", options: payPeriodOptions })
                    break;
                case "applicableToAll":
                    const value = defaultValues["applicableToAll"];
                    formValues["applicableToAll"] = EmployeeListService.getValueObjectFromDropdown(value ? "true" : "false", f.options, "id");
                    if (value) {
                        alteredConfig.push({ columnCode: "employees", uiVisible: false, options: PayrollManager.parseUserList(userList), validator: [{ key: "required", value: false }] })
                    } else {
                        alteredConfig.push({ columnCode: "employees", uiVisible: true, options: PayrollManager.parseUserList(userList), validator: [{ key: "required", value: true }] })
                    }
                    break;
                case "location":
                    const { isLocationActive, locationLabel } = getLocationValueAndLabel();
                    const locations = PayrollManager.parseLocationListData(locationListData);
                    formValues["location"] = Utility.isEmpty(defaultValues["location"]) || !isEdit  ? locations[0] : EmployeeListService.getValueObjectFromDropdown(defaultValues["location"], locations, "id");
                    alteredConfig.push({name: locationLabel, columnCode: "location", uiVisible: isLocationActive, options: locations });
                    break;
                case "employees":
                    const userOptions = PayrollManager.parseUserList(userList);
                    alteredConfig.push({ columnCode: "employees", options: userOptions });
                    formValues["employees"] = EmployeeListService.getValueFromMuliSelect(defaultValues.employees, userOptions, "id");
                    break;
                case "payDay":
                    const selectedPayPeriod = defaultValues["payPeriod"];
                    const payDayOptions = getPaydayOptionsFromPayperiod(selectedPayPeriod);
                    formValues["payDay"] = EmployeeListService.getValueObjectFromDropdown(defaultValues["payDay"], payDayOptions, "id");
                    alteredConfig.push({ columnCode: "payDay", options: payDayOptions });
                    break;
                default:
                    formValues[f.columnCode] = defaultValues[f.columnCode] ? defaultValues[f.columnCode] : "";
                    break;
            }
        });
        EmployeeListService.getAlteredConfigDetails(fields, alteredConfig, false, {}, {});
        updateColumnConfigWithCustomField(fields);
        fetchAndUpdateUsersList(formValues["location"], alteredConfig, fields, true);
        return fields;
    }

    const getLocationValueAndLabel = () => {
        const tenantDetails = TenantManager.getTenantDetails();
        let isLocationActive = false;
        let locationLabel = "";
        const additionalSettings = tenantDetails
            ? tenantDetails.additionalSettings
            : "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;
        locationLabel = isLocationActive
            ? locationSettings?.locationLabel
            : "";

        return { isLocationActive, locationLabel };
    }


    const updateColumnConfigWithCustomField = (columnConfig) => {
        let fieldConfig  = customFieldData?.customFields?.filter(field=>field.isActive) || [];
        fieldConfig?.forEach((c) => {
            let group = {};
            group['id'] = c.id;
            group['name'] = c.name;
            group['columnCode'] = c.id;
            group['key'] = c.id;
            group['uiVisible'] = true;
            group['required'] = c.isMandatory;
            group = getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldConfigOnType = (group, c) => {
        switch (c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                group['validator'] = [{ key: "maxLength", value: c.maxLength }];
                if (defaultValues[c.id]) {
                    formValues[c.id] = defaultValues[c.id];
                }
                if(c.isMandatory && group && group['validator']) {
                    group['validator'] = [...group['validator'],{key:"required", value: true} ]
                }
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                group['validator'] = [{ key: "decimalPrecision", value: c.decimalPrecision }];
                if (defaultValues[c.id]) {
                    formValues[c.id] = defaultValues[c.id];
                }
                if(c.isMandatory && group && group['validator']) {
                    group['validator'] = [...group['validator'],{key:"required", value: true} ]
                }
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return {
                        id: p,
                        name: p
                    }
                });
                group['type'] = INPUT_TYPE.DROPDOWN;
                group['options'] = options;
                group['isMultiSelect'] = true;
                if (defaultValues[c.id]) {
                    formValues[c.id] = EmployeeListService.getValueFromMuliSelect(defaultValues[c.id], options,"id");
                }
                group['validator'] = []
                if(c.isMandatory && group && group['validator']) {
                    group['validator'] = [...group['validator'],{key:"required", value: true} ]
                }
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                if (defaultValues[c.id]) {
                    formValues[c.id] = reverseTimezoneOffset(moment(defaultValues[c.id]).toDate());
                }  
                group['validator'] = []
                if(c.isMandatory && group && group['validator']) {
                    group['validator'] = [...group['validator'],{key:"required", value: true} ]
                }
                              
                break;    
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    const onChange = (v, c) => {
        const fields = deepClone(formFields);
        const alteredConfig = [];
        if (v && v === " ") {
            v = v.trim();
        }
        switch (c.columnCode) {
            case "applicableToAll":
                const value = EmployeeListService.getSelectedIdFromObject(v, "id");
                if (value === "true") {
                    alteredConfig.push({ columnCode: "employees", uiVisible: false, validator: [{ key: "required", value: false }] });
                } else if (value === "false") {
                    formValues["employees"] = [];
                    alteredConfig.push({ columnCode: "employees", uiVisible: true, validator: [{ key: "required", value: true }] });
                }
                formValues[c.columnCode] = v;
                break;
            case "location":
                const previousLocationValue = EmployeeListService.getSelectedIdFromObject(formValues[c.columnCode], "id");
                const selectedLocationValue = EmployeeListService.getSelectedIdFromObject(v, "id");
                if(selectedLocationValue != previousLocationValue) {
                    fetchAndUpdateUsersList(v, alteredConfig, fields, false);
                    formValues[c.columnCode] = v;
                    formValues["employees"] = [];
                }
                break;
            case "payPeriod":
                const previousPayPeriod = EmployeeListService.getSelectedIdFromObject(formValues[c.columnCode], "id"); 
                const selectedPayPeriod = EmployeeListService.getSelectedIdFromObject(v, "id");
                if(selectedPayPeriod != previousPayPeriod) {
                    formValues["payDay"] = {};
                    formValues[c.columnCode] = v;
                    const options = getPaydayOptionsFromPayperiod(selectedPayPeriod);
                    alteredConfig.push({columnCode:"payDay", options:options});
                }                
                break;
            default:
                formValues[c.columnCode] = v;
                let { invalid, errMsg } = checkFieldValidation(c, v);
                if (invalid) {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                } else {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                }
                break;
        }
        EmployeeListService.getAlteredConfigDetails(fields, alteredConfig, false, {}, {});
        setFormFields(fields);
    }

    const getPaydayOptionsFromPayperiod = (selectedPayPeriod) => {
        let optionArray = [];
        switch (selectedPayPeriod) {
            case "monthly":
                optionArray = payDayMonthly;
                break;
            case "weekly":
                let selectedWorkWeek = PayScheduleManager.getWorkingDays();
                let options = []

                workWeek.forEach((w, ind) => {
                    let i = selectedWorkWeek.findIndex(res => w.id == res)
                    if (ind == 0 || i != -1) {
                        options.push(w)
                    }
                })
                optionArray = options;
                break;
            case "twicePerMonth":
                optionArray = payDayTwicePerMonthDays;
                break;
            case "biWeekly":
                let biWeeklyPayDaysList = []
                let selectedWeek = PayScheduleManager.getWorkingDays();

                selectedWeek.forEach((workDay, ind) => {
                    if (workDay) {
                        biWeeklyPayDays.forEach((day, i) => {
                            if ((workDay) === (i) || (workDay + 7) === i) {
                                biWeeklyPayDaysList.push(day);
                            }
                        });
                    }
                })

                optionArray = biWeeklyPayDaysList;
                break;
            default:
                optionArray = payDayMonthly;
                break;
        }
        return optionArray;
    }

    const fetchAndUpdateUsersList = (v, alteredConfig, fields,isValueUpdate) => {
        setProcessing(true);
        const location = EmployeeListService.getSelectedIdFromObject(v, "id");
        if (!Utility.isEmpty(location)) {
            getUsersByLocation(location, fields, isValueUpdate);
        } else {
            getUsers(fields, isValueUpdate);
        }
        return alteredConfig;
    }

    const getUsersByLocation = (location, fields, isValueUpdate) => {
        // showLoader()
        PayrollService.getUsersByLocation(location).then((res) => {
            // removeLoader()
            if (res && res.users) {
                setAndUpdateUserOptions(res.users, fields, isValueUpdate);
            }
            setProcessing(false);
        }, (error) => {
            setProcessing(false);
        });
    }

    const getUsers = (fields, isValueUpdate) => {
        // showLoader()
        PayrollService.getUsersList().then((res) => {
            // removeLoader()
            if (res && res.users) {

                //To do- Let location selected employees in all users
                setAndUpdateUserOptions(res.users, fields, isValueUpdate);
            }
            setProcessing(false);
        }, (error) => {
            setProcessing(false);
        });
    }

    const setAndUpdateUserOptions = (users, fields, isValueUpdate) => {
        const updatedList = PayrollManager.parseUserList(users);
        const alteredFields = [{ columnCode: "employees", options: updatedList }]
        EmployeeListService.getAlteredConfigDetails(fields, alteredFields, false, {}, {});
        if(isValueUpdate) formValues["employees"] = EmployeeListService.getValueFromMuliSelect(defaultValues.employees, updatedList, "id");        
        setFormFields(fields);
        setUserList(users);
    }

    const getFieldRequired = (field) => {
        const validator = field.validator;
        let isRequired = false;
        if (!Utility.isEmpty(validator)) {
            const index = validator.findIndex((v) => v.key === "required");
            if (index != -1) {
                isRequired = validator[index].value;
            }
        }
        return isRequired;

    }

    const onSave = () => {
        const { params, invalid } = checkValidation();
        if (invalid) {
            return;
        }
        showLoader(`Payschedule is being ${isEdit ? "updated" : "added"}... Please wait.`);
        const paramters = getFormParams();
        if (isEdit) {
            paramters["_id"] = defaultValues["_id"];
            updatePayschedule(paramters);
        } else {
            addPayschedule(paramters);
        }

    }

    const addPayschedule = (paramters) => {
        PayScheduleService.addPaySchedule(paramters).finally(() => removeLoader()).then((response) => {
            if (response) {
                showToast(
                    `${isEdit ? "Payschedule Updated" : "Pay schedule Added"} Successfully`,
                    TOAST_TYPE.SUCCESS
                );
                ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.PAY_SCHEDULE)
                    .then(res => {
                        TenantManager.setProfileData(res['profileStages']);
                    });
                    onClose(true);
            }
        }, (error) => {
            if(error?.includes("no user found for selected location")) {
                showToast(t("NO_USER_FOUND_WITH_LOCATION"), TOAST_TYPE.ERROR);
            } else{
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
            }
        })
    }

    const updatePayschedule = (paramters) => {
        PayScheduleService.updatePaySchedule(paramters).finally(() => removeLoader()).then((response) => {
            showToast(
                `${isEdit ? "Pay schedule Updated" : "Pay schedule Added"} Successfully`,
                TOAST_TYPE.SUCCESS
            );
            ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.PAY_SCHEDULE)
                .then(res => {
                    TenantManager.setProfileData(res['profileStages']);
                });
                onClose(true);
        }, (error) => {
            if(error?.includes("no user found for selected location")) {
                showToast(t("NO_USER_FOUND_WITH_LOCATION"), TOAST_TYPE.ERROR);
            } else{
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
            }
        })
    }

    const getFormParams = () => {
        const customFieldsValues = getCustomFieldsData();
        let paramters = {
            name: formValues["payscheduleName"],
            payPeriod: EmployeeListService.getSelectedIdFromObject(formValues["payPeriod"], "id"),
            employees: EmployeeListService.getSelectedIdFromObject(formValues["applicableToAll"], "id") === "true"  ? [] : EmployeeListService.getValueForMultiSelect(formValues["employees"], PayrollManager.parseUserList(userList), "id"),
            isForAllUsers: EmployeeListService.getSelectedIdFromObject(formValues["applicableToAll"], "id") === "true",
            location: EmployeeListService.getSelectedIdFromObject(formValues["location"], "id"),
            customFields: customFieldsValues,
            payDay: EmployeeListService.getSelectedIdFromObject(formValues["payDay"], "id")
        }
        return paramters;
    }

    const getCustomFieldsData = () => {
        const customFieldsData = [];
        customFieldData?.customFields?.forEach((c) => {
            if (!Utility.isEmpty(formValues[c.id])) {
                let group = {
                    fieldId: c.id,
                    fieldName: c.name,
                    fieldValue: c.type === "date" ? [convertDateToJson(formValues[c.id])] : getCustomFieldInputValue(formValues[c.id], c.possibleValues)
                };
                customFieldsData.push(group);
            }
        });
        return customFieldsData;
    }

    const getCustomFieldInputValue = (value, options) => {
        let selectedValue = [];
        if (Array.isArray(value)) {
            value?.forEach((v) => {
            selectedValue.push(options[v]);
            })
        } else {
            selectedValue.push(value);
        }
        return selectedValue;
    }

    const checkValidation = () => {
        let config = deepClone(formFields);
        const params = {};
        const alteredConfig = [];
        const invalidFields = [];
        for (let c = 0; c < config.length; c++) {
            let { invalid, errMsg } = checkFieldValidation(config[c], formValues[config[c].columnCode]);
            if (invalid) {
                invalidFields.push(config[c].columnCode)
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
            } else {
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
                params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
            }
            switch (config[c].type) {
                case INPUT_TYPE.DROPDOWN:
                    params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
                    break;

                default:
                    params[config[c].columnCode] = formValues[config[c].columnCode]
                    break;
            }
        }
        const invalid = invalidFields.length > 0;
        if(invalid) {
            scrollToError(invalidFields.columnCode);
        }
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});
        setFormFields(config);
        return { params, invalid }
    }

    const checkFieldValidation = (config, value) => {
        const validation = config.validator
        let invalid = false;
        let errMsg = CONSTANTS.EMPTY_STRING;
        if (config.uiVisible && !Utility.isEmpty(validation)) {
            for (let v = 0; v < validation.length; v++) {
                switch (validation[v].key) {
                    case "required":
                        if (Utility.isEmpty(value)) {
                            invalid = true;
                            errMsg = "Enter a valid value"
                        }
                        break;
                    case "maxLength":
                        if (!Utility.isEmpty(value) && value.length > parseInt(validation[v].value)) {
                            invalid = true;
                            errMsg = `Length should not exceed ${validation[v].value} digits`
                        }
                        break;
                    case "decimalPrecision":
                        if (!Utility.isEmpty(value)) {
                            var result = (value - Math.floor(value)) === 0;
                            if (result) {
                                break
                            }
                            const valueArray = value.split(".");
                            if (valueArray.length > 1) {
                                const precisionValue = valueArray[1];
                                if (precisionValue.length > parseInt(validation[v].value)) {
                                    invalid = true;
                                    errMsg = `Length after decimal should not exceed ${validation[v].value} digits`
                                }
                            }
                        }
                        break;

                    default:
                        invalid = config.hasError;
                        errMsg = config.errMsg;
                        break;
                }
            }
        }
        return { invalid, errMsg }
    }

    const getFormSection = () => {
        return formFields.map((c) => {
            return (
                <>
                    {(c.type === INPUT_TYPE.TEXT || c.type === INPUT_TYPE.NUMBER || c.type === INPUT_TYPE.DATE) && c.uiVisible && (
                        <div
                            className="column p-h-l mb-xxl padding-bottom-mobile"
                            key={c.columnCode}
                        >
                            <DKInput
                                title={c.name}
                                placeholder={c.name}
                                value={formValues[c.columnCode]}
                                className=''
                                type={c.type}
                                labelClassName=" text-align-left "
                                onChange={(v) => {
                                    onChange(v, c);
                                }}
                                direction={c.direction}
                                required={getFieldRequired(c)}
                                readOnly={c.readOnly}
                                onClick={() => { }}
                                canValidate={c.hasError}
                                validator={(value) => {
                                    return !c.hasError;
                                }}
                                errorMessage={c.errMsg}
                                readOnly={isProcessing}
                            />
                        </div>
                    )}
                    {c.type === INPUT_TYPE.DROPDOWN && c.uiVisible && (
                        <div
                            className="column p-h-l  mb-xxl padding-bottom-mobile pay-schedule-group-dropdown"
                            key={c.columnCode}
                        >
                            <DKInput
                                title={c.name}
                                placeholder={c.name}
                                value={formValues[c.columnCode]}
                                className=''
                                formatter={(obj) => {
                                    /** How to render a selected option in case of object **/
                                    return obj.name;
                                }}
                                displayKey={"name"}
                                options={c.options}
                                type={c.type}
                                labelClassName=" text-align-left "
                                onChange={(v) => {
                                    onChange(v, c);
                                }}
                                direction={c.direction}
                                required={getFieldRequired(c)}
                                readOnly={c.readOnly}
                                onClick={() => { }}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: c.options && c.options.length > 3 ? true : false,
                                    searchableKey: "name",
                                    data: c.options,
                                    renderer: (index, obj) => {
                                        /*How to render dropdwon options from string of array*/
                                        return <DKLabel className="" text={obj.name} />;
                                    },
                                    onSelect: (index, value) => { },
                                    multiSelect: c.isMultiSelect,
                                }}
                                canValidate={c.hasError}
                                validator={(value) => {
                                    return !c.hasError;
                                }}
                                errorMessage={c.errMsg}
                                readOnly={isProcessing}
                            />
                        </div>
                    )}
                </>
            )
        })
    }


    const getHeader = () => {
        return (
            <div className="row justify-content-between p-m">
                <div className="row">
                    <DKLabel
                        text={`${!props.isEdit ? "Add Payschedule" : "Edit Payschedule"}`}
                        className="fw-b fs-m"
                    />
                    {isProcessing && <DKSpinner className="pl-s" />}
                </div>
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            onClose(true);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                        disabled={isProcessing}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className=" transparent-background">
            <div className="popup-window" style={{ padding: 0, minWidth: "36%", overflow: "hidden" }}>
                <div className="popup-wrapper parent-width parent-height pb-s" style={{ height: "62vh" }} >
                    {getHeader()}
                    <div className="parent-width custom-scroll" style={{ overflow: "auto", height: "calc(100% - 69px)" }}>
                        <div className=" p-v-m">
                            {getFormSection()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddEditPayschedule;
